<style lang="scss" src="./style.scss"></style>

<template>
  <svg
    v-show="show"
    :class="{ show: show }"
    class="spinner"
    width="44px"
    height="44px"
    viewBox="0 0 44 44"
  >
    <circle
      class="path"
      fill="none"
      stroke-width="4"
      stroke-linecap="round"
      cx="22"
      cy="22"
      r="20"
    />
  </svg>
</template>

<script>
export default {
  name: 'VSpinner',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
